import { getVersion } from '@/utils/systemCode';
import { safeJsonStringify, compareVersions } from '@/utils/tools';
import { getPureSignPopup } from '@/api/fuli';
import { getManufacturer } from './bridge';
import { signInListAdapter } from './helper';
import { FULI_MODULE } from '../consts';

/**
 * @description 签到信息适配器
 * @function signInfoAdapter
 * @param {Object} info 签到信息
 * @returns {Object} 签到信息适配结果
 */
export const signInfoAdapter = (info) => {
  const {
    bonusList = [],
    currentlyIsVip,
    moduleInfo = [],
    repeatSignDesc,
    bountyCountToday = 0,
    doSignThisTime,
    didSignToday = false, // 今日是否已签到
    title = '', // 副标题文案（如"已连签0天，断签重新开始"）
    titleIcon = '', // 标题图片（连签7天领xxx奖励金）
    bountyCountTomorrow = 0, // 明日签到可领奖励金
    extraRewardBtnText = '', // 额外奖励按钮文案，可能为空
    signBtnText = '立即签到', // 签到按钮文案
    extraConfig = {}, // 额外的配置信息
    canAddComponent,
  } = info;

  // 处理签到计划列表
  const { signInCardList, signInPopupList } = signInListAdapter(bonusList, { didSignToday });

  // 处理广告信息
  let bannerAdvertisementUnitId = '';
  let bannerTaskRelationCouponInfo = {};
  // 处理签到弹窗标题和描述
  let signInPopupTitle;
  let signInPopupDesc;

  if (moduleInfo && moduleInfo.length > 0) {
    const signInModule = moduleInfo.find(
      (item) => item.moduleKey === FULI_MODULE.welfare_attendance_new,
    );
    if (signInModule) {
      bannerAdvertisementUnitId = signInModule.bannerAdvertisementUnitId || '';
      bannerTaskRelationCouponInfo = signInModule.bannerTaskRelationCouponInfo || {};
    }
  }

  // 处理重复签到提示
  if (repeatSignDesc) {
    signInPopupTitle = repeatSignDesc;
    signInPopupDesc = '连续签到得更多奖励金';
  }

  return {
    signInAdInfo: {
      bannerAdvertisementUnitId,
      bannerTaskRelationCouponInfo,
    },
    signInPlanList: signInCardList,
    signInExtInfo: {
      isVip: currentlyIsVip,
      isRepeatSigned: !!repeatSignDesc,
      bountyCountToday,
      doSignThisTime,
      didSignToday,
      title,
      titleIcon,
      bountyCountTomorrow,
      extraRewardBtnText,
      signBtnText,
      signInPopupList,
      signInPopupTitle,
      signInPopupDesc,
      extraConfig,
      canAddComponent,
    },
    signInModuleInfo: moduleInfo,
  };
};

/**
 * @description 获取签到信息
 * @function getSignInData
 * @param {Object} params 参数
 * @returns {Object} 签到信息
 */
export const getSignInData = async (params = {}) => {
  try {
    // 获取设备厂商标识（iOS/Android 统一处理）
    const brand = await getManufacturer();

    const result = await getPureSignPopup({
      newWelfare: true,
      manufacturer: brand,
      ...params,
    });
    const { data } = result || {};
    const signInfo = signInfoAdapter(data);

    return { success: true, data: signInfo };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('getSignInData => error', safeJsonStringify(error));
    return { success: false, data: null };
  }
};

/**
 * @description 判断app是否支持手动签到
 * @function judgeManualSignVersion
 * @returns {Promise<boolean>} true=支持走app签到，false=不支持走H5兜底
 */
export const judgeManualSignVersion = async () => {
  try {
    const version = await getVersion();
    // 手动签到要求版本 >= 6.99.10
    return compareVersions(version, '6.99.10') !== -1;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(
      'judgeManualSignVersion => error',
      safeJsonStringify(error),
    );
    return false;
  }
};
